import styled from "styled-components";

import colors from "../../assets/css/colors";

export const Container = styled.div`
    padding: 32px 17px 60px 17px;
    margin-top: 64px;
    background: ${colors.grayLightest} 0% 0% no-repeat padding-box;
    border-radius: 35px;
`;

export const Title = styled.span`
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
`;

export const TransferBehindContainer = styled.div`
    width: 100%;
    height: 70px;
    margin-top: -62px;
    margin-bottom: 25px;
    background: ${colors.white} 0% 0% no-repeat padding-box;
    box-shadow: 0px 41px 74px #D15A0078;
    border-radius: 12px;
    opacity: 0.23;
`;

export const TransferDataContainer = styled.div`
    width: 100%;
    height: 70px;
    /* height: max-content; */
    background: ${colors.white} 0% 0% no-repeat padding-box;
    border-radius: 12px;
    opacity: 1;
`;

export const InfoContainer = styled.div`
    display: block;
    width: 100%;
`;

export const ImageContainer = styled.div`
    margin-left: 22px;
    height: 100%;
    display: flex;
    align-items: center;

    @media (max-width: 1024px){
        margin-left: 10px;
    }
`;

export const NameAndPlanContainer = styled.div`
    margin-left: 24px;

    @media (max-width: 1024px){
        margin-left: 12px;
    }
`;

export const FirstName = styled.div`
    margin: 0px;
    margin-bottom: 3px;
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
`;

export const PlanName = styled.div`
    font: normal normal 300 12px Muli;
    color: ${colors.planName};
`;

export const AmountPill = styled.div`
    width: auto;
    
    padding-right: 5px;
    padding-left: 5px;
    min-width: 50px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center; 
    margin-top: 8px;
    margin-right: 7px;
    background: #FFDE8D 0% 0% no-repeat padding-box;
    border-radius: 8px;
    font: normal normal bold 9px Muli;
    color: ${colors.lastTransferBackground};
`;